import React from "react";
import PropTypes from "prop-types";
import { formatAbn } from "utils/abn";
import { rctiTimestamp } from "utils/rctiTimestamp";
import { agreementReference } from "./RctiDesignSystem";

export default function SupplierInvitation({ agreement: a, onReview }) {
  const sender = a.buyerRepresentative?.name || a.buyer.name;
  const recipient = a.supplierRepresentative?.name || a.supplier.name;
  return (
    <section className="supplier-invitation-page">
      <header className="rcti-design-heading">
        <div>
          <h1>Please sign your RCTI agreement — {a.buyer.name}</h1>
          <p>
            Agreement invitation · Prepared{" "}
            {rctiTimestamp(a.createdAt || a.buyerSignedAt)}
          </p>
        </div>
      </header>
      <article className="supplier-invitation-card">
        <dl className="supplier-invitation-envelope">
          <dt>From</dt>
          <dd>
            {sender} · {a.buyer.name}
            {a.buyer.emailAddress && ` <${a.buyer.emailAddress}>`}
          </dd>
          <dt>To</dt>
          <dd>
            {recipient}
            {a.supplier.emailAddress && ` <${a.supplier.emailAddress}>`}
          </dd>
          <dt>Subject</dt>
          <dd>Please sign your RCTI agreement — {a.buyer.name}</dd>
        </dl>
        <p className="agreement-review-brand">{a.buyer.name}</p>
        <h2>You’re invited to review &amp; sign</h2>
        <p>
          Hi{" "}
          {a.supplierRepresentative?.name?.trim().split(/\s+/)[0] ||
            a.supplier.name}
          ,
        </p>
        <p>
          {a.buyer.name} invites you to review a recipient created tax invoice
          (RCTI) agreement on behalf of {a.supplier.name}.
        </p>
        <p>
          The agreement lets {a.buyer.name} determine the value and issue RCTIs
          for your covered taxable supplies: {a.scope} Please review all terms
          and confirm your authority before signing.
        </p>
        <div className="supplier-invitation-summary">
          <span className="rcti-agreement-badge rcti-agreement-badge--proposed">
            Awaiting signature
          </span>
          <p>
            {agreementReference(a._id)} · Wording v{a.version} · Prepared{" "}
            {rctiTimestamp(a.createdAt || a.buyerSignedAt)}
          </p>
          <p>
            Buyer: {a.buyer.name} · ABN {formatAbn(a.buyer.abnNumber)}
            <br />
            Supplier: {a.supplier.name} · ABN {formatAbn(a.supplier.abnNumber)}
          </p>
          <p>Effective only when you accept · No fixed expiry</p>
          <p>
            Sign by{" "}
            {a.invitationExpiresAt
              ? rctiTimestamp(a.invitationExpiresAt)
              : "7 days after creation"}
            . Resending does not extend this deadline.
          </p>
        </div>
        <button type="button" onClick={onReview}>
          Review &amp; sign agreement
        </button>
        <p>
          This is an agreement invitation, not an invoice. Signing does not
          create a tax invoice, RCTI number or payment obligation. If unsigned,
          the invitation expires seven days after creation.
        </p>
        <p>
          Thanks,
          <br />
          {sender}
          <br />
          {a.buyerRepresentative?.position ||
            "Authorised representative"} · {a.buyer.name}
          <br />
          {a.buyer.emailAddress}
        </p>
        <footer>
          Sent using invoice &amp; recover, the software provider.{" "}
          {a.buyer.name} is the buyer and prospective issuer. Review the
          complete agreement before accepting. Once accepted, it continues while
          eligible unless either party suspends it.
        </footer>
      </article>
    </section>
  );
}
SupplierInvitation.propTypes = {
  agreement: PropTypes.object.isRequired,
  onReview: PropTypes.func.isRequired,
};
